(() => {
  const node = document.querySelector('[data-edg-monthly-config]');
  if (!node || window.EDGMonthlyOpenings) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const base = config.base || '/';
  const kinds = ['collar', 'adapter'];
  const productIds = Object.fromEntries(kinds.map(kind => [kind, new Set(config[kind].ids.map(String))]));
  const classify = id => kinds.find(kind => productIds[kind].has(String(id))) || '';
  function batchProperties(kind, properties = {}) {
    const result = {...properties};
    if (!kinds.includes(kind)) return result;
    const batch = config[kind];
    if (!batch.canOrder || !/^\d{8}$/.test(batch.batchId || '') || !batch.startDate || !batch.shipDate) throw new Error(config.messages[kind]);
    if (result['_EDG Batch'] && (result['_EDG Batch'] !== batch.batchId || result['_EDG Batch Start'] !== batch.startDate || result['Expected ship date'] !== batch.shipDate)) throw new Error(config.messages.batchChanged);
    return {...result, 'Production batch': batch.startLabel, 'Production starts': batch.startLabel, 'Expected ship date': batch.shipDate, 'Usual shipping window': batch.shippingWindow, 'Shipping note': config.messages.shippingNote, '_EDG Batch': batch.batchId, '_EDG Batch Start': batch.startDate, '_EDG Batch Category': kind};
  }
  const counts = cart => (cart.items || []).reduce((sum, item) => {
    const kind = classify(item.product_id);
    if (kind) sum[kind] += Number(item.quantity) || 0;
    return sum;
  }, {collar: 0, adapter: 0});
  const problem = cart => {
    const total = counts(cart);
    for (const kind of kinds) {
      if (total[kind] && !config[kind].canOrder) return config.messages[kind];
    }
    for (const item of cart.items || []) {
      const kind = classify(item.product_id);
      if (!kind) continue;
      const properties = item.properties || {};
      const batch = config[kind];
      if (properties['_EDG Batch'] !== batch.batchId || properties['_EDG Batch Start'] !== batch.startDate || properties['_EDG Batch Category'] !== kind || properties['Production batch'] !== batch.startLabel || properties['Production starts'] !== batch.startLabel || properties['Expected ship date'] !== batch.shipDate) return config.messages.batchChanged;
    }
    return '';
  };
  let feedbackTimer;
  function feedback(message) {
    const box = document.querySelector('[data-edg-opening-feedback]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(() => { box.hidden = true; }, 9000);
  }
  function openSignup(kind) {
    const details = document.getElementById('edg-opening-alerts');
    if (!details) return false;
    details.open = true;
    const select = document.getElementById('EDGOpeningInterest');
    if (select && ['collar', 'adapter', 'both'].includes(kind)) {
      select.value = 'newsletter,edg-opening-alerts,edg-openings-' + kind;
    }
    details.scrollIntoView({behavior: 'auto', block: 'start'});
    return true;
  }
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const alertLink = target && target.closest('[data-edg-opening-alert]');
    if (alertLink && openSignup(alertLink.dataset.edgOpeningAlert || 'both')) event.preventDefault();
  });
  const params = new URLSearchParams(location.search);
  if (location.hash === '#edg-opening-alerts' || params.has('customer_posted') || document.querySelector('#EDGOpeningAlerts .edg-opening-success, #EDGOpeningAlerts [role="alert"]')) {
    openSignup(params.get('opening_interest') || 'both');
  }
  const pageClosed = config.pageKind && !config[config.pageKind].canOrder;
  if (pageClosed) document.documentElement.classList.add('edg-monthly-product-closed');
  const addSelector = '[data-add-build], button[name="add"], input[name="add"], .product-form__submit, [data-add-to-cart]';
  function blockProduct(event) {
    if (!pageClosed) return;
    const target = event.target instanceof Element ? event.target : null;
    if (event.type === 'click' && (!target || !target.closest(addSelector))) return;
    if (event.type === 'submit' && (!target || !target.matches('form[action*="/cart/add"]'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    feedback(config.messages[config.pageKind]);
    const notice = document.querySelector('[data-edg-opening-product-notice]');
    if (notice) notice.scrollIntoView({behavior: 'auto', block: 'start'});
  }
  document.addEventListener('click', blockProduct, true);
  document.addEventListener('submit', blockProduct, true);
  const pageVariants = new Set((config.pageVariants || []).map(String));
  function productForm(form) {
    return form instanceof HTMLFormElement && form.matches('form[action*="/cart/add"]') && pageVariants.has(String(new FormData(form).get('id')));
  }
  function prepareForm(event) {
    if (!config.pageKind || pageClosed) return;
    const target = event.target instanceof Element ? event.target : null;
    const control = event.type === 'click' && target && target.closest(addSelector);
    const form = event.type === 'submit' ? target : control && (control.form || control.closest('form'));
    if (!productForm(form)) return;
    try {
      const existing = Object.fromEntries(Array.from(form.querySelectorAll('input[name^="properties["]')).map(input => [input.name.slice(11, -1), input.value]));
      const properties = batchProperties(config.pageKind, existing);
      for (const [key, value] of Object.entries(properties)) {
        const name = 'properties[' + key + ']';
        let input = Array.from(form.elements).find(element => element.name === name);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
        input.value = value;
      }
    } catch (error) { event.preventDefault(); event.stopImmediatePropagation(); feedback(error.message); }
  }
  document.addEventListener('click', prepareForm, true);
  document.addEventListener('submit', prepareForm, true);
  async function readCart() {
    const response = await fetch(base + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error(config.messages.failed);
    return response.json();
  }
  function showCart(cart) {
    const issue = problem(cart);
    document.documentElement.classList.toggle('edg-monthly-cart-closed', Boolean(issue));
    const status = document.querySelector('[data-edg-opening-cart-status]');
    if (status) {
      const total = counts(cart);
      status.textContent = issue || (total.collar || total.adapter ? config.messages.ready : config.messages.tags);
    }
    return issue;
  }
  let checking = false;
  const replay = new WeakSet();
  async function checkout(event) {
    const target = event.target instanceof Element ? event.target : null;
    const control = target && target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href^="/checkout?"]');
    const cartForm = event.type === 'submit' && target && target.matches('form[action*="/cart"]') && event.submitter && event.submitter.name === 'checkout';
    const action = cartForm ? event.submitter : control;
    if (!action) return;
    if (replay.has(action)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    try {
      const cart = window.EDGLinkedCart ? await window.EDGLinkedCart.ready() : await readCart();
      const issue = showCart(cart);
      if (issue) feedback(issue);
      else {
        replay.add(action);
        if (cartForm) target.requestSubmit(action);
        else action.click();
        setTimeout(() => { replay.delete(action); }, 0);
      }
    } catch { feedback(config.messages.failed); }
    finally { checking = false; }
  }
  document.addEventListener('click', checkout, true);
  document.addEventListener('submit', checkout, true);
  let refreshTimer;
  const refresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => { readCart().then(showCart).catch(() => {}); }, 200);
  };
  document.addEventListener('eurus:cart:items-changed', refresh);
  document.addEventListener('cart:updated', refresh);
  if (config.pageType === 'cart') refresh();
  window.EDGMonthlyOpenings = {classify, counts, problem, batchProperties, guardsCheckout: true};
})();

